export class PagedResults<T, K> {
  public results: T[];
  public pageMetadata: PageMetadata;

  constructor(backEndPagedResults?: BackEndPagedResults<K>, fromBackend?: ((arg: K) => T)) {
    if (backEndPagedResults) {
      this.results = backEndPagedResults.results.map(result => fromBackend(result));
      this.pageMetadata = new PageMetadata(backEndPagedResults.page_metadata);
    }
  }
}

export interface BackEndPagedResults<T> {
  results: T[];
  page_metadata: BackEndPageMetadata;
}

export class PageMetadata {
  public pageSize: number;
  public pageNumber: number;
  public totalResults: number;
  public totalPages: number;

  constructor(backEndPageMetadata?: BackEndPageMetadata) {
    if (backEndPageMetadata) {
      this.pageSize = backEndPageMetadata.page_size;
      this.pageNumber = backEndPageMetadata.page_number;
      this.totalResults = backEndPageMetadata.total_results;
      this.totalPages = backEndPageMetadata.total_pages;
    }
  }
}

export interface BackEndPageMetadata {
  page_size: number;
  page_number: number;
  total_results: number;
  total_pages: number;
}
